<template>
  <div class="bg-container">
    <div class="login">
      <van-nav-bar>
        <template #left>
          <van-icon name="arrow-left" color="#2a2723" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="logo">
        <img src="/img/login/logo2.png" alt="">
      </div>
      <div class="form">
        <div class="input_wrap">
          <van-icon name="contact-o" size="18" color="#bfa06a"></van-icon>
          <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
        </div>
        <div class="input_wrap">
          <van-icon name="lock" size="18" color="#bfa06a"></van-icon>
          <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
          <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#bfa06a" size="18" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
        </div>
        <div class="input_wrap">
          <van-icon name="invitation" size="18" color="#bfa06a"></van-icon>
          <input type="text" :placeholder="$t('auth.invite_code_place')" v-model="code">
        </div>
        <div class="button" @click="doRegister()">{{$t("auth.register")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pwdType: 1,
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  mounted(){
    
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.van-nav-bar {
  background: none;
  .van-icon {
    font-size: 1.38rem;
  }
}
.bg-container {
  background: @bg-page;
  height: 100%;
}
.login {
  height: 100%;
  width: 100%;
  padding: 3.3rem 1.7rem 2rem;
  background: @bg-page;
  overflow: auto;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 0.12rem;
    background: @gold;
  }
}

.logo {
  width: 9.2rem;
  margin: 1.5rem 0 0.4rem;
  img{
    width: 100%;
    display: block;
    filter: brightness(0) saturate(100%);
    opacity: 0.88;
  }
}

.form {
  margin-top: 1.5rem;
  padding-top: 0.2rem;
  border-top: 1px solid @line;
}

.input_wrap{
  height: 3.55rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid @line;
  input{
    flex: 1;
    width: 0;
    height: 100%;
    border: none;
    background: none;
    outline: none;
    text-align: left;
    font-size: .95rem;
    margin-left: 0.75rem;
    color: @text-title;
    &::placeholder {
      color: @text-sub;
    }
  }
}

.button{
  width: 100%;
  background: @wine;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.06rem;
  color: #fff;
  text-align: center;
  height: 3.15rem;
  line-height: 3.15rem;
  border-radius: 0.12rem;
  margin: 2rem 0 0;
}
</style>
